
import * as moment from "moment-timezone";

/* Verify email format: return true if proper email format
 * in: email
 */
export const VarifyEmail = (email) => {
    var pattern = new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);
    if (pattern.test(email)) {    
        return true;
    } else {
        return false;
    }
};

/* Time Zone Name
 */
export const GetTimeZoneName = () => {
    const abbrs = {
        EST: 'Eastern Time',
        EDT: 'Eastern Time',
        CST: 'Central Time',
        CDT: 'Central Time',
        MST: 'Mountain Time',
        MDT: 'Mountain Time',
        PST: 'Pacific Time',
        PDT: 'Pacific Time',
    };
    return abbrs;
};

// overwirte moment function
moment.fn.zoneName = function () {
    var abbr = this.zoneAbbr();
    var abbrs = GetTimeZoneName();
    return abbrs[abbr] || abbr;
};

/* Get current date time in UTC
 */
export const UTCDateTimeNow = () => {
    let d = new Date();
    return moment(d).utc().format();
}

/* Convert DateTime from UTC to ET
 */
export const ZoneDateTime = (timeZone, utcTime) => {
    if (!timeZone || !utcTime) {
        return '';
    }

    const utc = moment(utcTime + 'Z');
    const zonetime = utc.tz("America/New_York").format('MM/DD/YYYY HH:mm');
    return zonetime;
}

/* Construct Event Date and Time
 */
export const EventDateTime = (utcStart, utcEnd, timeZone) => {
    let eventDate = [];

    if (utcStart && utcEnd) {
        let localStartDate = ZoneDateTime(timeZone, utcStart);
        let localEndDate = ZoneDateTime(timeZone, utcEnd);

        // create moment object with date and time
        let sDateTime = moment(localStartDate);
        let eDateTime = moment(localEndDate);

        // create moment object with only date
        let sDate = moment(localStartDate.split('T')[0]);
        let eDate = moment(localEndDate.split('T')[0]);

        let zoneName = moment.tz(timeZone).format('zz');

        if (sDate.diff(eDate, 'days') || sDate.month() !== eDate.month()) {
            if (sDate.year() !== eDate.year()) {
                eventDate[0] = moment(sDateTime).format('MMMM D, YYYY') + " - " + moment(eDateTime).format('MMMM D, YYYY');
                eventDate[1] = '';
            } else if (sDate.month() !== eDate.month()) {
                eventDate[0] = moment(sDateTime).format('MMMM D') + " - " + moment(eDateTime).format('MMMM D, YYYY');
                eventDate[1] = '';
            } else {
                eventDate[0] = moment(sDateTime).format('MMMM D') + " - " + moment(eDateTime).format('D, YYYY');
                eventDate[1] = '';
            }
        } else {
            let startFormat = moment(sDateTime).format('dddd, MMMM Do, YYYY ; h:mm A') + " - " +
                moment(eDateTime).format('h:mm A') + ' (' + zoneName + ')';            
            eventDate = startFormat.split(';');
        }
    }

    return eventDate;
}